import { useTranslation } from "react-i18next";
import { Add } from "iconsax-react";
import { Button } from "@/shared/ui";

interface Props {
  onAddClick?: () => void;
  showAddButton?: boolean;
}

export default function EmployeesHeader({ onAddClick, showAddButton }: Props) {
  const { t } = useTranslation("EmployeesPage");

  return (
    <div className="flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke mb-5">
      <h1 className="text-display-xs content-base-primary">{t("header.title")}</h1>
      {showAddButton && onAddClick && (
        <Button variant="primary" onClick={onAddClick}>
          <Add size={16} color="currentColor" />
          {t("header.addWorker")}
        </Button>
      )}
    </div>
  );
}

